<template>
  <!-- exibe as informações de um trabalho específico -->
  <div>
    <div class="row col-md-12">
      <!-- coluna do trabalho -->
      <div :class="{'col-md-10': trabalho.trabalho_completo != '', 'col-md-12': trabalho.trabalho_completo == ''}">
        <div class="trabalho-titulo-autores">
          <div class="trabalho-id-wrapper">
            <div class="rotate">
              <div class="trabalho-id">{{ trabalho.id }}</div>
            </div>
          </div>
          <div class="trabalho-titulo-autores-content">
            <div class="trabalho-titulo">{{ trabalho.titulo }}</div>
            <div class="trabalho-autores">
              <template v-for="(a, index) in trabalho.todos_autores">
                <span v-if="index != 0"> ; </span>
                <router-link :to="'/autor/'+a.id" class="trabalho-autor">{{ a.nome }}<sup>{{ trabalho.instituicoes.indexOf(a.instituicao) + 1 }}</sup></router-link>
              </template>
            </div>
          </div>
        </div>
      </div>

      <!-- coluna do download -->
      <div class="col-md-2" v-if="trabalho.trabalho_completo != ''">
        <div class="text-right download-wrapper">
          <div>
            <a :href="trabalho.trabalho_completo" class="btn btn-primary btn-lg text-center">
              <i class="fa fa-download"></i>
              <br/>
              {{ $t('baixar_trabalho') }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- a próxima linha vai ter instituições, eixo, palavras-chaves -->
    <!-- e na outra coluna o resumo -->
    <div class="row">
      <div class="col-md-12">
        <!-- vou chamar de side-info -->
        <div class="row-side-info">
          <div><b>{{ $tc('instituicao', 2) | capitalize }}</b></div>
          <!-- as instituições agora -->
          <div v-for="(i, index) in trabalho.instituicoes">
            <router-link :to="{name:'trabalhos', params:{pesquisa:i}}">
              <sup>{{ index+1 }}</sup>{{ i }}
            </router-link>
          </div>
        </div>

        <div class="row-side-info">
          <div><b>{{ $tc('eixo', 2) | capitalize }}</b></div>
          <div>
            <router-link :to="{name:'trabalhos', params:{pesquisa:trabalho.eixo.nome}}">
              {{ trabalho.eixo.nome }}
            </router-link>
          </div>
        </div>

        <div class="row-side-info" v-if="trabalho.palavras_chaves.length">
          <div><b>{{ $tc('palavra_chave', 2) | capitalize }}</b></div>
          <div v-for="(p, index) in trabalho.palavras_chaves">
            <router-link :to="{name:'trabalhos', params:{pesquisa:p.palavra_chave}}">
              <sup>{{ index+1 }}</sup>{{ p.palavra_chave }}
            </router-link>
          </div>
        </div>
      </div>

      <template v-if="trabalho.resumo!=''">
        <div class="col-md-12 resumo"><b>{{ $tc('resumo', 1) | capitalize }}:</b></div>
        <div class="col-md-12 resumo">
          <p v-for="line in trabalho.resumo_parsed.split('\n')" v-if="line.trim()!=''">
            {{ line }}
          </p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import removeAccents from 'remove-accents'
import { i18n } from '@/langs/anais'

export default {
  name: 'anaisTrabalho',
  props: {},
  components: {},
  data () {
    return {};
  },
  filters: {},
  watch: {},
  computed: {
    trabalho() {
      if(this.$route.params.trabalho_id) {
        let trabalho_id = this.$route.params.trabalho_id
        let ret = this.trabalhos.find(t => t.id == trabalho_id)
        if(!ret) {
          // não encontrei o autor
          // volto para autores
          this.$router.replace('/trabalhos')
          return this.trabalhos[0]
        }
        return ret
      }
      return null
    },

    // eu preciso fazer um computed
    // pq eu qro acessar essas variáveis diretamente do <template>
    eixos() { return eixos }, autores() { return autores }, palavras_chaves() { return palavras_chaves }, trabalhos() { return trabalhos },
  },
  created: function () {},
  mounted: function () {},
  methods: {},
  i18n: i18n
}
</script>

<style type="text/css" scoped>
/*o trabalho quando estou visualizando apenas um*/
.trabalho-id-wrapper {
  left: 0;
  top: 0;
  bottom: 0;
  background: #B7453C;
  width: 20px;
  position: absolute;
  color: white;
}
.rotate {
  font-size: 14px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%,-50%) rotate(-90deg);
}
.trabalho-id::before {
  content: '#';
}
.trabalho-id {
  letter-spacing: 2px;
}
.trabalho-titulo-autores {
  position: relative;
}
.trabalho-titulo {
  font-size: 32px;
  color: black;
  line-height: 32px;
  text-align: justify;
}
.trabalho-titulo-autores-content {
  margin-left: 24px;
}


.download-wrapper {
  font-size: 20px;
}
.download-wrapper > div {
  /*cada linha do download wrapper deve manter uma distância do outro*/
  margin-bottom: 10px;
}


.resumo {
  text-align: justify;
}
.row-side-info {
  text-align: justify;
  margin-bottom: 20px;
}
.row-side-info sup {
  margin-right: 5px;
}
.row-side-info a {
  color: unset;
}
.row-side-info a:hover {
  text-decoration: none;
}
.instituicao {
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// AnaisTrabalho.vue?329e12e6